import React, { useCallback, useEffect, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { BoxClass } from '../../../helper/classes'
import { Popover } from '@blueprintjs/core'
import { OverlayProps, sidebarDirection } from '../../../helper/configs'
import { globalOnDemandVars } from '../../../helper/context'
import { getIdForRenderTileInJSON } from '../../list/window2/functions'
import { defer, uniqueId } from 'lodash'
// pixelMode 의 값들 여기서 가져옴
import {
  exampleValuesForSpreadsheet, exampleValuesForUploadType2, exampleValuesForUploadType22,
  MosaicFor1,
  MosaicFor2,
  TreeDataFor1,
  TreeDataFor2, TreeDataFor4,
  TreeDataFor5
} from '../../../helper/variables'
import { Spreadsheet } from '../../list/spreadsheet/classes'
import { Type2Or3Item } from '../../list/uploadType2/class'

let initialRadioValue = '3'

function PixelModeControlPadAddOn () {
  const [radioValue, setRadioValue] = useState(initialRadioValue)
  useEffect(() => {
    /*
    * visual로 편집한 treeData랑 mosaicValue를 얻기위해 쓰는거
    * reactotorn에서 이거 본다음에 clipboard로 텍스트 붙여넣기하는 버튼 누르며 됨
    * 그리고!!!! path array중에 legacy id들로 이루어진 path가 있고 그것들은 수동으로 수정해줘야됨...
    * 예를들어 visual로 편집하기전 id로 3이랑 4가 있었으면 편집후에 그게 없어졌어도 path array가 [3, 4] 일 수 있고 그럼 안됨
    * */
    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'tree values',
        value: {
          pixelTreeData: globalOnDemandVars.pixelTreeData(),
          mosaicValueForPixelMode: globalOnDemandVars.mosaicValueForPixelMode(),
          globalTreeData: globalOnDemandVars.globalTreeData(),
          mosaicValue: globalOnDemandVars.mosaicValue(),
          type1Items: globalOnDemandVars.type1Items()
        }
      // , important: true
      })
    }
  }, [radioValue])

  const setEnv = useCallback(
    (radioValue) => {
      let newMosaicValue
      switch (radioValue) {
        case '1':
          globalOnDemandVars.set_mosaicValueForPixelMode(null)
          globalOnDemandVars.set_pixelTreeData(TreeDataFor1)
          globalOnDemandVars.set_Window2InitialValueForPixelMode(MosaicFor1)
          defer(() => {
            globalOnDemandVars.set_mosaicValueForPixelMode(MosaicFor1)
            defer(() => {
              globalOnDemandVars.set_lastClosedListForPixelMode([])
            })
            // globalOnDemandVars.set_treeChangeDetectForPixelMode(!(globalOnDemandVars.treeChangeDetectForPixelMode()))
          })
          break
        case '2':
          globalOnDemandVars.set_mosaicValueForPixelMode(null)
          globalOnDemandVars.set_pixelTreeData(TreeDataFor2)
          globalOnDemandVars.set_Window2InitialValueForPixelMode(MosaicFor2)
          defer(() => {
            globalOnDemandVars.set_mosaicValueForPixelMode(MosaicFor2)
            defer(() => {
              globalOnDemandVars.set_lastClosedListForPixelMode([])
            })
          })
          break
        case '3':
          globalOnDemandVars.set_mosaicValueForPixelMode(null)
          newMosaicValue = getIdForRenderTileInJSON(uniqueId(), [])
          globalOnDemandVars.set_pixelTreeData([])
          globalOnDemandVars.set_Window2InitialValueForPixelMode(newMosaicValue)
          defer(() => {
            globalOnDemandVars.set_mosaicValueForPixelMode(newMosaicValue)
            defer(() => {
              globalOnDemandVars.set_lastClosedListForPixelMode([])
            })
          })
          break
        case '4':
          if (!globalOnDemandVars.uploadType2s()['exampleUploadType2Id']) {
            defer(() => {
              const uploadType2 = new Type2Or3Item({ id: 'exampleUploadType2Id' })
              globalOnDemandVars.uploadType2s()['exampleUploadType2Id'] = uploadType2
              uploadType2.setForPixelMode(exampleValuesForUploadType2)

              const uploadType22 = new Type2Or3Item({ id: 'exampleUploadType2Id2' })
              globalOnDemandVars.uploadType2s()['exampleUploadType2Id2'] = uploadType22
              uploadType22.setForPixelMode(exampleValuesForUploadType22)
            })
          }
          globalOnDemandVars.set_mosaicValueForPixelMode(null)
          globalOnDemandVars.set_pixelTreeData(TreeDataFor4)
          globalOnDemandVars.set_Window2InitialValueForPixelMode(MosaicFor2)
          defer(() => {
            globalOnDemandVars.set_mosaicValueForPixelMode(MosaicFor2)
            defer(() => {
              globalOnDemandVars.set_lastClosedListForPixelMode([])
            })
          })
          break
        case '5':
          if (!globalOnDemandVars.spreadsheets()['exampleSpreadsheetId']) {
            defer(() => {
              const spreadsheet = new Spreadsheet('exampleSpreadsheetId')
              globalOnDemandVars.spreadsheets()['exampleSpreadsheetId'] = spreadsheet
              spreadsheet.setForPixelMode(exampleValuesForSpreadsheet)
            })
          }
          globalOnDemandVars.set_mosaicValueForPixelMode(null)
          globalOnDemandVars.set_pixelTreeData(TreeDataFor5)
          globalOnDemandVars.set_Window2InitialValueForPixelMode(MosaicFor2)
          defer(() => {
            globalOnDemandVars.set_mosaicValueForPixelMode(MosaicFor2)
            defer(() => {
              globalOnDemandVars.set_lastClosedListForPixelMode([])
            })
          })
          break
        default:
          globalOnDemandVars.set_mosaicValueForPixelMode(null)
          newMosaicValue = getIdForRenderTileInJSON(uniqueId(), [])
          globalOnDemandVars.set_pixelTreeData([])
          globalOnDemandVars.set_Window2InitialValueForPixelMode(newMosaicValue)
          defer(() => {
            globalOnDemandVars.set_mosaicValueForPixelMode(newMosaicValue)
            defer(() => {
              globalOnDemandVars.set_lastClosedListForPixelMode([])
            })
          })
          break
      }
    }
    ,
    []
  )

  const onRadioChange = useCallback(
    (e) => {
      setRadioValue(e.target.value)
      setEnv(e.target.value)
      initialRadioValue = e.target.value
    }
    ,
    [setEnv]
  )

  return (
    <div id={'pixelController'} css={css`text-align: center !important; margin: 10px 0 10px 0;`} className={'letItBePixel'}>
      <Popover {...OverlayProps} popoverClassName={'popoverWithPixel letItBePixel'} position={globalOnDemandVars.insertConfig().sidebarDirection === 'right' ? 'left-top' : 'right-top'} content={
        <div className={'nes-balloon' + (sidebarDirection === 'right' ? ' from-right' : ' from-left')}>
          <p css={css`font-size: 1.2em;`}>The contents here will not be saved, also there is a reset button<br />You can try anything here and feel free to screw things up</p>
        </div>
      }>
        <button className={'nes-btn is-warning'} css={css`font-size: 4em; margin-bottom: 20px !important;`}>?</button>
      </Popover>
      <div className={'nes-container with-title is-centered is-rounded'} css={css`margin: 0 auto 10px auto !important; min-width: 60%;`}>
        <p className='title'>Set Environment</p>
        <div css={css`font-size: 1.2em;`}>
          <label>
            <input type='radio' className='nes-radio' value={'3'} onChange={onRadioChange} checked={radioValue === '3'} />
            <span>New Page</span>
          </label>
          <br />
          <label>
            <input type='radio' className='nes-radio' value={'1'} onChange={onRadioChange} checked={radioValue === '1'} />
            <span>Example 1</span>
          </label>
          <br />
          <label>
            <input type='radio' className='nes-radio' value={'2'} onChange={onRadioChange} checked={radioValue === '2'} />
            <span>Example 2</span>
          </label>
          <br />
          <label>
            <input type='radio' className='nes-radio' value={'4'} onChange={onRadioChange} checked={radioValue === '4'} />
            <span>Upload Type 2 Example</span>
          </label>
          <br />
          <label>
            <input type='radio' className='nes-radio' value={'5'} onChange={onRadioChange} checked={radioValue === '5'} />
            <span>Spreadsheet Example</span>
          </label>
        </div>
      </div>
      <button className={'nes-btn'} onClick={() => { setEnv(radioValue) }}>Reset</button>
    </div>
  )
}

const PixelModeControlPadAddOnBoxClass = new BoxClass(PixelModeControlPadAddOn, 'Control Pad', null, 1, { order: -1, defaultOpen: true, initialHeight: 380, onlyForTheseLocations: ['/pixel'], letItBePixel: true, backgroundColor: 'yellow' })

export default PixelModeControlPadAddOnBoxClass
